import { VehicleForm } from 'components/vehicle'
import { Button } from 'core/components/button'
import { PlateMask } from 'core/constants'
import { toLocaleDateTime } from 'core/helpers/date'
import { applyMask, maskMoney } from 'core/helpers/mask'
import { classNames } from 'core/helpers/misc'
import { useRefresh } from 'core/hooks/refresh'
import { addHours, parseISO } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { API } from 'service'

export const Dashboard = ({ global, basename, service, route }) => {
  const { modal, operator } = global
  const refresh = useRefresh()
  const showForm = route.location.pathname.includes('veiculo')

  const [balance, setBalance] = useState(0)
  const [vehicles, setVehicles] = useState([])
  const [lastParkings, setLastParkings] = useState([])

  const isCustomer = operator.user.permissions?.includes('Customer')

  useEffect(() => {
    Promise.all([
      API.get(`customer.balance/me`),
      API.post('vehicle.listOwner', { plates: [] }),
      API.post('customerstatement.list', {
        usePager: false,
        sort: [{ name: 'createdAt', order: 'DESC' }],
        filters: [
          {
            items: [
              {
                name: 'createdAt',
                value: addHours(new Date(), -4),
                comparer: 'GreaterThanOrEqual',
              },
              {
                name: 'statementTypeId',
                value: [2, 3],
                comparer: 'Contains',
              },
            ],
          },
        ],
      }),
    ])
      .then(([resp, vehicle, statement]) => {
        setBalance(resp.balance)
        setVehicles(vehicle.items)
        setLastParkings(statement.items)
      })
      .catch(err => modal.alert(err.message))
    // eslint-disable-next-line
  }, [refresh.ref])

  return (
    <>
      <div className="kt-portlet kt-portlet--border-bottom-brand">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <span className="kt-portlet__head-icon">
              <i className="kt-font-brand fas fa-home" />
            </span>
            <h3 className="kt-portlet__head-title">Olá seja bem-vindo, {operator.user.name}.</h3>
          </div>
        </div>
        <div className="kt-portlet__body kt-portlet__body--fluid">
          <div className="kt-widget26">
            <div className="kt-widget26__content">
              <span className="kt-widget26__number">{maskMoney(balance)}</span>
              <span className="kt-widget26__desc">Saldo Disponível </span>
              {isCustomer && (
                <Button
                  customClassName="btn-brand btn-block kt-mt-20"
                  icon="fas fa-dollar-sign"
                  title="Comprar Créditos"
                  onClick={`${basename}/comprar-creditos`}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {isCustomer && (
        <div className="row">
          <div className="col-lg kt-mb-20 kt-align-right">
            <Button
              customClassName="btn-block btn-success"
              icon="fas fa-plus"
              title="Novo Veículo"
              onClick={`${basename}/veiculo/cadastro`}
            />
          </div>
        </div>
      )}

      <div className="row">
        {vehicles.map(v => (
          <div className="col-md-4 vehicle-col" key={v.plate}>
            <div
              className={classNames('kt-portlet', {
                'kt-portlet--solid-danger': v.hasDebit,
              })}
            >
              <div
                className="kt-portlet__head kt-portlet-button"
                onClick={() =>
                  route.history.push(`${basename}/ativar-cartao-digital`, {
                    plate: v.plate,
                    vehicleTypeId: v.vehicleTypeId || 1,
                  })
                }
              >
                <div className="kt-portlet__head-label">
                  <span className="kt-portlet__head-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 525.48 525.48"
                      width={32}
                      height={32}
                    >
                      <path
                        fill="#C50000"
                        d="M274.65.5A261.93 261.93 0 0 0 .5 250.84a261.93 261.93 0 0 0 250.32 274.14 261.93 261.93 0 0 0 274.14-250.32A261.93 261.93 0 0 0 274.65.5z"
                      />
                      <path
                        fill="#FFF"
                        d="M272.38 50.46c-117.24-5.33-216.6 85.4-221.92 202.64-5.33 117.24 85.4 216.6 202.64 221.92 117.24 5.32 216.6-85.4 221.92-202.64 5.32-117.24-85.4-216.6-202.64-221.92z"
                      />
                      <path d="M161.26 418.74v-302.4h220.05v60.3H220.66v49.5h90.9v60.3h-90.9v72h164.7v60.3h-224.1z" />
                    </svg>
                  </span>
                  <h3 className="kt-portlet__head-title">
                    {v.description
                      ? `${v.description} (${applyMask(PlateMask, v.plate)})`
                      : applyMask(PlateMask, v.plate)}
                  </h3>
                </div>

                {v.hasDebit && <div className="kt-portlet__head-toolbar">Em Débito</div>}
              </div>
            </div>

            {isCustomer && (
              <>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => route.history.push(`${basename}/veiculo/${v.plate}`)}
                >
                  <i aria-hidden="true" className="fas fa-pen" />
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() =>
                    global.modal.confirm(
                      `Deseja remover esse veículo: ${applyMask(PlateMask, v.plate)}?`,
                      confirmed =>
                        confirmed &&
                        service
                          .post('vehicle.change', { ...v, remove: true })
                          .then(refresh.force)
                          .catch(err => global.modal.alert(err.message)),
                    )
                  }
                >
                  <i aria-hidden="true" className="fas fa-trash-alt" />
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="row">
        <div className="col-md">
          <div className="kt-portlet">
            <div className="kt-portlet__head">
              <div className="kt-portlet__head-label">
                <h3 className="kt-portlet__head-title">Últimas ativações</h3>
              </div>
            </div>
            <div className="kt-portlet__body">
              {lastParkings.map(item => (
                <div className="kt-mb-5" key={item.id}>
                  {applyMask(PlateMask, item.parking.plate)} -{' '}
                  {toLocaleDateTime(parseISO(item.parking.localValidFrom))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <VehicleForm
        service={service}
        show={showForm}
        route={route}
        refresh={refresh.force}
        global={global}
        vehicles={vehicles}
      />
    </>
  )
}
